export const facetChanged = 'facetChanged'
export const mapChanged = 'mapChanged'
export const viewTypeChanged = 'viewTypeChanged'
